export const getPayerData = (state) => {
  return state.payerData;
};

export const getPayerFieldsAreValid = (state) => {
  let validationArray = [];
  for (const field in state.payerValidationFields) {
    validationArray.push(state.payerValidationFields[field].valid);
  }
  if (validationArray.length) {
    return validationArray.every((item) => item === true);
  } else {
    return false;
  }
};

export const getDowngradeData = (state) => {
  return state.downgradeData;
};
